<template>
    <!-- ========== TESTIMONIALS ========== -->
    <section id="testimonials" class="lightgrey_bg">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="main_title mt_wave a_left" v-if="title!=null">
                        <h2>{{ title[currentLanguage] }}</h2>
                    </div>
                    <p class="main_description" v-if="header != null">
                        {{ header[currentLanguage] }}
                    </p>
                </div>

                <div class="col-md-6">
                    <slider animation="fade" style="z-index: 0;" class="Testimonials" v-if="testimonials.length > 0">
                        <slider-item v-for="testimonial in testimonials" :key="testimonial.id">
                            <testimonial :testimonial="testimonial"></testimonial>
                        </slider-item>
                    </slider>
                    <div v-if="testimonials.length == 0">
                        <p class="text-center testimonials-empty" >
                            <i class="fa fa-comment-o"></i>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import testimonial from './Testimonial.vue';
    import config from '../../config/app';
    import {Slider, SliderItem} from 'vue-easy-slider';
    import $http from '../../HttpRequest';
    let _ = require('lodash');
    export default {
        data : function(){
            return  {
                testimonials : [],
                title : null,
                header : null
            }
        },
        components : {
            testimonial,
            Slider,
            SliderItem
        },
        computed : {
            currentLanguage : function()
            {
                return this.$language;
            }
        },
        mounted : function(){
            let self = this;
            let config = this.$store.getters.config;
            if( !_.isNull(config) )
            {
                self.testimonials = self.$store.getters.config.testimonials.items.slice(0,5);
                self.title = self.$store.getters.config.testimonials.title;
                self.header = self.$store.getters.config.testimonials.header;
            }
        },
        created : function(){
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !_.isNull(self.$store.getters.config) )
                {
                    self.testimonials = self.$store.getters.config.testimonials.items.slice(0,5);
                    self.title = self.$store.getters.config.testimonials.title;
                    self.header = self.$store.getters.config.testimonials.header;
                }
            });
        },
        beforeDestroy : function(){
            this.unsubscribe();
        },
        methods : {
            tr : function(t){
                return this.translate( this.$language, t);
            }
        }
    }
</script>

<style lang="scss">
    .Testimonials
    {
        .btn
        {
            &.btn-left
            {
                display: none;
            }
            &.btn-right
            {
                display: none;
            }
        }
        .indicators
        {
            position: absolute;
            transform: translateX(0) !important;
            left: 30px !important;
            .slider-indicator-active
            {
                background-color: #00A0D1;
            }
        }
    }
    .testimonials-empty
    {
        padding-top: 4.5em;
        i
        {
            font-size: 15em;
            opacity: 0.3;
        }
    }
</style>


// WEBPACK FOOTER //
// Testimonials.vue?5351d802